module.exports = __webpack_public_path__ + "static/media/allLogo.cc6c4577.jpg";